import { Card, styled } from '@driftt/dds'

export const StyledCardEvent = styled(Card, { padding: '$2' })
